import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LibImageEditorComponent } from './lib-image-editor.component';

@NgModule({
  declarations: [LibImageEditorComponent],
  imports: [CommonModule],
  exports: [LibImageEditorComponent],
})
export class LibraryImageEditorModule {}
